export default __webpack_public_path__ + "static/media/3.7f5d22db.jpg";